<script>
/**
 * The default button to use to for confirming/accepting something
 */
export default {
  props: {
    /**
     * The text you want to appear in the button
     */
    text: {
      type: String,
      default: 'Submit'
    }
  },

  data() {
    return {
      styles: [
        'px-4',
        'py-2',
        'mr-3',
        'border',
        'border-transparent',
        'text-sm',
        'font-medium',
        'rounded-md',
        'shadow-sm',
        'text-gray-100',
        'bg-blue-600',
        'hover:bg-blue-600',
        'focus:outline-none',
        'focus:ring-2',
        'focus:ring-offset-2',
        'focus:ring-indigo-500'
      ]
    }
  }
}
</script>

<template>
  <button :class="styles">{{ text }}</button>
</template>
